import * as React from 'react';
import TwoColRow from './TwoColRow';
const DeliveryInformationRow = ({ i18n, formatDate, formatTime, reportStore: { order } }) => {
    var _a, _b;
    return (React.createElement(React.Fragment, null,
        React.createElement(TwoColRow, { label: i18n('readreport.label.orderRecipients'), value: (_a = order.orderRecipientUser) === null || _a === void 0 ? void 0 : _a.map(x => x.userNameAndSurName).join(', ') }),
        React.createElement(TwoColRow, { label: i18n('readreport.label.readBy'), value: React.createElement(React.Fragment, null, (_b = order.readReceipt) === null || _b === void 0 ? void 0 : _b.map((x, i) => (React.createElement("div", { key: i },
                x.userNameAndSurName,
                " (",
                formatDate(x.time),
                " ",
                formatTime(x.time),
                ")")))) })));
};
export default DeliveryInformationRow;
